import _extends from '../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.error.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.date.now.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.date.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.to-string.js';
import '../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.regexp.to-string.js';
import { __rest, __assign } from '../../node_modules/.pnpm/node_modules/tslib/tslib.es6.js';
import React, { forwardRef, useMemo } from 'react';
import RcForm from 'rc-field-form';
import classNames from 'classnames';
import useForm from '../hooks/useForm.js';
import FormContext from '../context/FormContext.js';
import './index.less.js';

var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  var form = props.form,
    name = props.name,
    className = props.className,
    style = props.style,
    children = props.children,
    restProps = __rest(props, ["form", "name", "className", "style", "children"]);
  var formCls = classNames('ti-form', className);
  var wrapForm = useForm(form)[0];
  var TI_FORM_INTERNAL = wrapForm.TI_FORM_INTERNAL;
  var key = useMemo(function () {
    return name !== null && name !== void 0 ? name : Date.now().toString();
  }, []);
  TI_FORM_INTERNAL.name = key;
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: __assign(__assign({}, TI_FORM_INTERNAL), {
      context: wrapForm
    })
  }, /*#__PURE__*/React.createElement(RcForm, _extends({}, restProps, {
    id: key,
    name: key,
    form: wrapForm,
    ref: ref,
    className: formCls,
    style: style
  }), children));
});

export { Form as default };
